export default {
  loading: {
    text: "拼命加載中",
  },
  title: "地址轉賬情況",
  subtitle: "數據統計幣種：",
  dialogTitle: "地址轉賬情況",
  empty: "暫無數據",
  filters: {
    currency: "幣種",
    selectCurrency: "請選擇幣種",
  },
  types: {
    transactionAmount: "交易數量",
    transactionCount: "交易次數",
  },
  units: {
    amount: "金額",
    times: "次數",
  },
  actions: {
    enlarge: "放大查看",
  },
};
